import { useCallback } from 'react';

import { useCurrentLocale } from '#features/i18n';
import { formatDistanceToNow } from '../utils/formatDistanceToNow';
import { useUserTimeSettings } from './useUserTimeSettings';

export const useFormatDistanceToNow = () => {
  const currentLocale = useCurrentLocale();
  const { timeZone, timeFormat } = useUserTimeSettings();

  return useCallback(
    (dateInput: string | Date, addSuffix: boolean = true, strict?: boolean) =>
      formatDistanceToNow(dateInput, addSuffix, {
        locale: currentLocale,
        timeZone,
        timeFormat,
        strict,
      }),
    [currentLocale, timeZone, timeFormat]
  );
};
